// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__20wuJ","row":"styles_row__1-mTF","link":"styles_link__1YdkH","atomName":"styles_atomName__3hnrE"};